import React from 'react';
import { makeStyles, Icons } from '~/lib/bn-material-ui';
import baseStyles from './base-styles';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => ({
  ...baseStyles(theme.palette.yellow[10], theme.palette.yellow[20]),
  extraMarginTop: {
    marginTop: '3.5rem',
  },
}));

export default function NoDevice() {
  const styles = useStyles();
  return (
    <div className={classNames(styles.bar, styles.extraMarginTop)}>
      <Icons.WarningRounded className={styles.icon} fontSize='large' />
      <span>
        <strong>No Device: </strong>Request device installation or configure as a standard bin.
      </span>
    </div>
  );
}
